/* eslint-disable @typescript-eslint/no-explicit-any */
export class DialogConfig<D = any> {
  width?: string;
  height?: string;
  backgroundColor?: string;
  data?: D;
}
